import qs from 'qs';
import { network } from 'services/network';

export const getUserImage = (params) => {
    const querystring = qs.stringify({ email: params.email }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getUserImage${querystring}`;
    return network
        .post(url, null, {
            transformRequest: [
                (data, headers) => {
                    if (headers) {
                        headers.Accept = 'image/png';
                    }
                    return data;
                },
            ],
            responseType: 'blob',
        })
        .then((response) => {
            return response.data;
        });
};
